import { type Company } from 'pages/Company/contexts/CompanyContext';

export const isMsp = (company?: Pick<Company, 'company_type'>) =>
    !!company && ['Reseller', 'Provider'].includes(company.company_type);
